export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4094dff92cc942375602db854f5866a4a29faf60ec&name=revalidateCommunity!'